import { useRecordContext, useTranslate } from 'react-admin';
import CustomMorePopover from '@/components/global/buttons/CustomMorePopover';
import CustomShowModalButton from '@/components/global/buttons/CustomShowModalButton.jsx';
import { useDrawer } from '@/composables/useDrawer';
import HistoryIcon from '@mui/icons-material/History';

export const TransactionMoreActions = () => {
    const record = useRecordContext();
    const { openDrawer } = useDrawer();
    const translate = useTranslate();

    if (!record) return null;

    return (
        <CustomMorePopover record={record}>
            <CustomShowModalButton
                onOpen={() => openDrawer(record.id, 'transaction-history')}
                label={translate('resources.transaction.history.action')}
                icon={<HistoryIcon sx={{ fontSize: 20 }} />}
            />
        </CustomMorePopover>
    );
};

TransactionMoreActions.propTypes = {};
